import React from 'react';
export function Footer() {
  return <footer className="w-full bg-slate-900 px-8 py-14 text-stone-50 sm:px-14" data-id="element-135" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-6xl" data-id="element-136" data-mp="3ggaqfufcyb4x">
        <p className="font-serif text-3xl tracking-tight" data-id="element-137" data-mp="3ghc0pwojutll">
          RELIGIONE PRONTA<span className="align-super text-[0.5em]" data-id="element-138" data-mp="32pfh6h0y5s0t">™</span>
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-50/60" data-id="element-139" data-mp="36oo5359b2vog">
          RELIGIONE PRONTA™ è un materiale didattico indipendente e non è una pubblicazione ufficiale del
          Ministero dell'Istruzione e del Merito né della CEI.
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-140" data-mp="36d08okdmdj3">
          © 2026 RELIGIONE PRONTA™ · edulabs. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}